<template>
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="32" cy="32" r="31" fill="white" stroke="#B4B5B7" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M36 32C36 29.7909 34.2091 28 32 28C29.7909 28 28 29.7909 28 32C28 34.2091 29.7909 36 32 36C34.2091 36 36 34.2091 36 32ZM30 32C30 30.8954 30.8954 30 32 30C33.1046 30 34 30.8954 34 32C34 33.1046 33.1046 34 32 34C30.8954 34 30 33.1046 30 32Z"
      fill="#8A8A8F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M32 17.1863C24.4382 17.1863 19.2399 21.4883 16.5478 29.8808C16.2905 30.6829 17.0794 31.4242 17.8639 31.1177C24.1623 28.6571 28.8915 27.4329 32 27.4329C35.1085 27.4329 39.8377 28.6571 46.1361 31.1177C46.9206 31.4242 47.7095 30.6829 47.4522 29.8808C44.7601 21.4883 39.5618 17.1863 32 17.1863ZM32.3474 19.1897C38.1044 19.3036 42.193 22.2658 44.7096 28.2191L44.816 28.477L44.631 28.4096C39.2118 26.428 35.0133 25.4329 32 25.4329L31.6947 25.4362C28.8085 25.4981 24.8888 26.4266 19.9068 28.2147L19.183 28.477L19.2904 28.2191C21.8573 22.1467 26.0598 19.1863 32 19.1863L32.3474 19.1897Z"
      fill="#8A8A8F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.1718 34.9911C21.431 33.4945 23.4465 32.7617 24.47 32.7617C26.5548 32.7617 29.308 35.264 30.7192 38.5339C31.3226 39.9321 31.5708 42.3967 31.5128 46.016C31.5023 46.6711 30.8753 47.1393 30.2442 46.9632C26.52 45.9242 23.8372 44.5614 22.1974 42.8324C20.6369 41.1871 19.1428 39.0344 17.7088 36.3744C17.4348 35.8661 17.647 35.232 18.1718 34.9911ZM28.8829 39.3264C27.7546 36.7121 25.6086 34.7617 24.47 34.7617C23.9478 34.7617 22.4735 35.2706 20.2056 36.2688L19.99 36.364L20.3122 36.9154C21.3097 38.593 22.3276 40.0039 23.3633 41.1482L23.6485 41.4561C24.7729 42.6416 26.6112 43.6779 29.1641 44.5403L29.519 44.657L29.5113 44.0686C29.4668 41.8809 29.2682 40.3318 28.9367 39.4593L28.8829 39.3264Z"
      fill="#8A8A8F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M40.0508 32.7617C41.0743 32.7617 43.0897 33.4945 46.349 34.9911C46.8737 35.232 47.0859 35.8661 46.8119 36.3744C45.3779 39.0344 43.8839 41.1871 42.3233 42.8324C40.6835 44.5614 38.0008 45.9242 34.2765 46.9632C33.6455 47.1393 33.0184 46.6711 33.0079 46.016C32.95 42.3967 33.1982 39.9321 33.8016 38.5339C35.2128 35.264 37.966 32.7617 40.0508 32.7617ZM40.0508 34.7617C38.9121 34.7617 36.7661 36.7121 35.6378 39.3264L35.5841 39.4593C35.2525 40.3318 35.0539 41.8809 35.0095 44.0686L35.0017 44.657L35.3566 44.5403C37.9095 43.6779 39.7478 42.6416 40.8722 41.4561L41.1575 41.1482C42.1932 40.0039 43.211 38.593 44.2085 36.9154L44.5307 36.364L44.3151 36.2688C42.0473 35.2706 40.573 34.7617 40.0508 34.7617Z"
      fill="#8A8A8F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M52 32C52 20.9543 43.0457 12 32 12C20.9543 12 12 20.9543 12 32C12 43.0457 20.9543 52 32 52C43.0457 52 52 43.0457 52 32ZM14 32C14 22.0589 22.0589 14 32 14C41.9411 14 50 22.0589 50 32C50 41.9411 41.9411 50 32 50C22.0589 50 14 41.9411 14 32Z"
      fill="#8A8A8F"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'DrivingTheKids',
};
</script>
